export const YTPlayerVars: YT.PlayerVars = {
    autoplay: 0, // Auto-play the video on load
    cc_load_policy: 1, // show closed captions
    color: 'white', // white player
    controls: 1, // always show controls
    enablejsapi: 1, // enable API control of the iframe
    origin: window.location.origin, // domain
    playsinline: 1, // playinline on iOS, 0 = full screen first
    rel: 0 // suggested videos have to come from the same channel
}
